import { Link } from 'react-router-dom';
import CookieBanner from './CookieBanner';

export default function Footer() {
  return (
    <footer className="bg-dark text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Columna 1: Logo y descripción */}
          <div className="break-words">
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-primary rounded-lg p-2 flex items-center justify-center flex-shrink-0">
                <i className="ri-delete-bin-line text-2xl text-white"></i>
              </div>
              <div className="flex flex-col min-w-0">
                <span className="font-bold text-lg sm:text-xl leading-tight text-white truncate">
                  JUSTCLEAN VIC
                </span>
                <span className="text-xs leading-tight text-gray-300">
                  Vaciado de pisos
                </span>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed break-words">
              Especialistas en vaciado de pisos y locales en Vic y comarca de Osona. Servicio profesional y discreto.
            </p>
          </div>

          {/* Columna 2: Enlaces rápidos */}
          <div className="break-words">
            <h4 className="font-bold text-sm sm:text-base mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-secondary transition-colors text-sm break-words">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/empresa" className="text-gray-300 hover:text-secondary transition-colors text-sm break-words">
                  Empresa
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-gray-300 hover:text-secondary transition-colors text-sm break-words">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-secondary transition-colors text-sm break-words">
                  Preguntas Frecuentes
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-300 hover:text-secondary transition-colors text-sm break-words">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 3: Servicios */}
          <div className="break-words">
            <h4 className="font-bold text-sm sm:text-base mb-4">Nuestros Servicios</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li className="break-words">Vaciado de pisos y casas</li>
              <li className="break-words">Vaciado de locales comerciales</li>
              <li className="break-words">Limpieza síndrome de Diógenes</li>
              <li className="break-words">Retirada de muebles</li>
              <li className="break-words">Limpieza extrema</li>
              <li className="break-words">Pintura y reparaciones</li>
            </ul>
          </div>

          {/* Columna 4: Contacto */}
          <div className="break-words">
            <h4 className="font-bold text-sm sm:text-base mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-secondary"></i>
                </div>
                <span className="text-gray-300 text-sm break-words">
                  Carrer de Jacint Verdaguer, 15<br />
                  08500 Vic, Barcelona
                </span>
              </li>
              <li className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-phone-line text-secondary"></i>
                </div>
                <a href="tel:+34602365996" className="text-gray-300 hover:text-secondary transition-colors text-sm break-words">
                  602 36 59 96
                </a>
              </li>
              <li className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-mail-line text-secondary"></i>
                </div>
                <a href="mailto:info@vic.justclean.es" className="text-gray-300 hover:text-secondary transition-colors text-sm break-all">
                  info@vic.justclean.es
                </a>
              </li>
            </ul>
            <div className="mt-4 flex space-x-3">
              <a
                href="https://wa.me/34602365996"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-secondary hover:bg-primary rounded-full transition-colors flex-shrink-0"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Línea divisoria */}
        <div className="border-t border-gray-700 mt-6 sm:mt-8 pt-6 sm:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-xs sm:text-sm text-center md:text-left break-words px-2">
              © {new Date().getFullYear()} JUSTCLEAN VIC. Todos los derechos reservados.
            </p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-xs sm:text-sm px-2">
              <a href="#" className="text-gray-400 hover:text-secondary transition-colors whitespace-nowrap">
                Aviso Legal
              </a>
              <a href="#" className="text-gray-400 hover:text-secondary transition-colors whitespace-nowrap">
                Política de Privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-secondary transition-colors whitespace-nowrap">
                Política de Cookies
              </a>
            </div>
          </div>
          <div className="text-center mt-4">
            <p className="text-gray-500 text-xs">
              © {new Date().getFullYear()} JUSTCLEAN VIC. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
      
      {/* Cookie Banner */}
      <CookieBanner />
    </footer>
  );
}
